import { Environment } from './environment.model';

/**
 * Configuración de Entorno DESARROLLO (DEV)
 * Conectado al backend de integración en la nube con observability
 */
export const environment: Environment = {
  pwaEnabled: true,
  production: false,
  name: 'dev',
  apiUrl: 'https://api.lom-dev.dpyra.es',
  apiTimeoutMs: 15000,
  enableApiInspector: true,
  enableMockFallback: false,
  features: {
    darkMode: true,
    inspectorModal: true,
    multiLeague: true,
    matchSimulation: true,
    googleLogin: true,
  },
};
